import React, { useState, useEffect } from "react";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomInputLabel,
  CustomRequiredInputLabel,
  CustomTextFeild,
  CustomTextFeildforFamily,
} from "../../common/StyledComponents/StyledFields";
import dayjs from "dayjs";
import { apiRequest } from "../../../infrastructure/backendService";
import { PersonSearch } from "@mui/icons-material";
import {  Box, Grid, InputAdornment } from "@mui/material";
import ButtonLoader from "../../common/ButtonLoader/ButtonLoader";
import ReportsSearchDevotee from "../ReportsSearchDevotee/ReportsSearchDevotee";
import CustomSelectField from "../../CompactCustomComponents/CustomSelectField";
import CustomDatePickerField from "../../CompactCustomComponents/CustomDatePickerField";

const formFieldsPoojaBookingReport = {
  signInName: "",
  dateFrom: "",
  dateTo: "",
  specialEvents: "",
};

const VolunteerReport = ({ sendDataToParent, getReportData }: any) => {
  const [formData, setFormData] = useState(formFieldsPoojaBookingReport);
  const [loading, setLoading] = useState<boolean>(false);
  const [events, setEvents] = useState<any>([{}]);

  useEffect(() => {
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/treasury/VOLUNTEER_REPORT/eventList",
      includeToken: true,
    })
      .then((res) => {
        setEvents(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [formData.specialEvents]);

  const getVolunteerReport = () => {
    const reqBody = {
      ...(formData.signInName && {
        searchUserName: formData.signInName.toUpperCase(),
      }),
      ...(formData.dateFrom && { poojaFromDate: formData.dateFrom }),
      ...(formData.dateTo && { poojaToDate: formData.dateTo }),
      ...(formData.specialEvents && { eventId: formData.specialEvents }),
      pagination: true,
      pageNumber: 0
    };
    setLoading(true);
    apiRequest({
      method: "POST",
      endpoint: "/report-dashboard/reports/treasury/VOLUNTEER_REPORT/browser",
      body: JSON.stringify(reqBody),
      includeToken: true,
    })
      .then((res) => {
        setLoading(false);
        sendDataToParent(true, {reqBody, 
          totalElements:res.data.totalElements,
          pageSize:res.data.pagesize,
          totalNumberofHours:res.data.totalDonatedAmount});
        const response = res.data.data.map((report: any) => {
          return {
            "Sign-in name": report.name,
            Event: report.event,
            Description: report.description,
            Date: report.date,
            "Start Time": report.starttime,
            "No of Hours worked": report.totalhours,
          };
        });
        getReportData(response);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlSubmitBookReport = async () => {
    try {
      getVolunteerReport();
    } catch (error) {}
  };

  const handleFieldChange = (field: any, value: any) => {
    if (field === "dateFrom" || field === "dateTo") {
      const formattedDate = dayjs(value, "YYYY-MM-DD");
      setFormData({
        ...formData,
        [field]: formattedDate.isValid()
          ? formattedDate.format("YYYY-MM-DD")
          : "",
      });
    } else {
      setFormData({
        ...formData,
        [field]: value,
      });
    }
  };

  // Search Devotee setters and handlers
  const [openSearchDevotee, setOpenSearchDevotee] = useState(false);

  const handleOpenSearchDevoteeDialog = () => {
    setOpenSearchDevotee(true);
  };

  const handleClose = () => {
    setOpenSearchDevotee(false);
  };

  const hanldeSelectUser = (username: string) => {
    handleFieldChange("signInName", username?.toUpperCase());
    handleClose();
  };


 let  minDate = dayjs().subtract(2, 'year').startOf('year'); // January 1st of last year
 let  maxDate = dayjs().endOf('year'); // December 31st of current year

  const DatePickerFrom = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        date={formData.dateFrom}   
        minDate={minDate}
        maxDate={maxDate}
        handleDateChange={handleFieldChange}
        errorMessage={undefined}
        name="dateFrom"
        format="MM-DD-YYYY"
        disableFuture     
      />
    );
  };

  const DatePickerTo = (): React.ReactElement => {
    return (
      <CustomDatePickerField
        minDate={minDate}
        maxDate={maxDate}
        date={formData.dateTo}
        handleDateChange={handleFieldChange}
        errorMessage={undefined}
        name="dateTo"
        format="MM-DD-YYYY"
        disableFuture
      />
    );
  };

  const SpecialEventsDropDown = (): React.ReactElement => {
    return (
      <CustomSelectField
        id="grouped-select"
        handleDropdownChange={handleFieldChange}
        errorMessage={""}
        dropDownList={events}
        value={formData.specialEvents}
        fieldName="specialEvents"
        placeholder={""}
        optionLabel="name"
        optionValue="eventid"
        overrideStyles={{ backgroundColor: "white" }}
      />
    );
  };

  const handleClear = () => {
    setFormData({ ...formFieldsPoojaBookingReport });
  };

  return (
    <Box sx={{maxWidth:"450px"}}>
      <Grid container  rowSpacing={"10px"} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={6} >
          <CustomInputLabel>Sign-In Name</CustomInputLabel>
          <CustomTextFeild
            fullWidth
            required
            value={formData.signInName}
            onChange={(e) => {
              handleFieldChange("signInName", e.target.value);
            }}
            className='text_field compact_fields bg_white'
            onBlur={() => {
              const inputUserName = formData.signInName.toUpperCase();
              handleFieldChange("signInName", inputUserName);
            }}
            sx={{
              background: "white !important",
              "& .MuiOutlinedInput-root": {
                pr: "7px",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <PersonSearch
                    sx={{ ml: "10px", cursor: "pointer", color: "#F05802" }}
                    onClick={handleOpenSearchDevoteeDialog}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
      <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={6} >
          {CustomRequiredInputLabel("Special Events", false)}
          {SpecialEventsDropDown()}
        </Grid>
      </Grid>
      <Grid container columnSpacing={"12px"} rowSpacing={"10px"} sx={{ marginTop: "0px" }}>
        <Grid item xs={12} sm={6} >
          {CustomRequiredInputLabel("From", false)}
          {DatePickerFrom()}
        </Grid>
        <Grid item xs={12} sm={6}>
          {CustomRequiredInputLabel("To", false)}
          {DatePickerTo()}
        </Grid>
      </Grid>
      <Grid sx={{ mt: 3, display: "flex", gap: "16px" }}>
        <CommonButton
          sx={{ width: "fit-content", height: "38px" }}
          onClick={handlSubmitBookReport}
          disabled={loading}
          id="submit"
        >
          <ButtonLoader isBtnLoading={loading} btnText={"Submit"} />
        </CommonButton>
        <CommonOutlinedButton onClick={handleClear}>Reset</CommonOutlinedButton>
        {openSearchDevotee && (
          <ReportsSearchDevotee
            open={openSearchDevotee}
            handleClose={handleClose}
            hanldeSelectUser={hanldeSelectUser}
          />
        )}
      </Grid>
    </Box>
  );
};
export default VolunteerReport;
